exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".draggable-event[data-v-36588c21] {\n  position: fixed;\n}\n", ""]);

// exports
